import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/together_tag.png'


const _withScopeId = n => (_pushScopeId("data-v-1859b65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container participate-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column flex-sm-row align-items-center justify-content-center gap-4"
}
const _hoisted_4 = { class: "mt-5 text-center d-flex justify-content-center align-items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  width: "180",
  alt: "챌린지 카드 이미지",
  class: "img_tag"
}
const _hoisted_6 = { class: "input-org-name-wrapper font-Pretendar" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = { class: "form-item row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cola-color col-12 mb-sm-5 text-14 text-50" }, " 소속명(본인 이름, 팀명, 직장명, 학교 등) ", -1))
const _hoisted_11 = { class: "form-item mt-sm-5 pt-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cola-color col-12 fw-bold text-14 text-50" }, " 참여인원 ", -1))
const _hoisted_13 = { class: "text-center d-flex justify-content-center mt-sm-5 mt-3 pt-sm-5" }

import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import type { Challenge } from './model/challenge';
import ChallengeCard from '@/templates/campaign-cocacola-season-6/components/challenge-card.vue';
import { formatDate, formatDateRange } from '@/templates/campaign-cocacola-season-6/static';
import { ref } from 'vue';
import ParticipantNumberInput from '@/templates/campaign-cocacola-season-6/components/participant-number-input.vue';

interface Props {
  challenges: Challenge[];
  type: 'participate' | 'collect';
  challengeType: 'everyone' | 'campus';
}

interface FormType {
  collection_challenge?: 2 | 4;
  people_collection?: 'individual' | 'group_type';
  group_name?: string;
  collecting_people_number?: number;
  organization_type?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenges: null,
    type: null,
    challengeType: null
  },
  emits: ['next'],
  setup(__props: any, { emit }) {

const props = __props as {
  challenges: Challenge[];
  type: 'participate' | 'collect';
  challengeType: 'everyone' | 'campus';
}


const formRef = ref<HTMLFormElement>();

const form = ref<FormType>({
  collecting_people_number: 1
});



const maxPeopleNumber = 10000;

let maxInput = 100000;
if (props.type === 'participate') {
  maxInput = maxPeopleNumber;
}


const isActive = (challenge: Challenge): boolean => {
  const now = new Date();
  if (props.type === 'participate') {
    return !!(challenge.recruitmentFrom && challenge.recruitmentTo &&
           now >= challenge.recruitmentFrom && now <= challenge.recruitmentTo);
  } else {
    return !!(challenge.collectionFrom && challenge.collectionTo &&
           now >= challenge.collectionFrom && now <= challenge.collectionTo);
  }
};
const activateChallenge = ref<Challenge | undefined>(
    props.challenges.find((c) => isActive(c))
);



const handleSubmit = () => {
  const formData = {
    ...form.value,
    challenge_id: activateChallenge.value?.id,
    challenge: activateChallenge.value,
    programId: activateChallenge.value?.programId
  };
  emit('next', formData);
};

const selectRound = (challenge: Challenge) => {
  if (isActive(challenge)) {
    activateChallenge.value = challenge;
  }
};

const imgTitle = props.challengeType === 'everyone' ? require('../images/participate-banner-title.png') : require('../images/participate-banner-title-2.png');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(imgTitle),
        alt: "참여하기 배너",
        class: "img-fluid mb-5 title-img"
      }, null, 8, _hoisted_2),
      (__props.challenges.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.challenges, (challenge, index) => {
              return (_openBlock(), _createBlock(ColaButton, {
                key: challenge.id,
                class: _normalizeClass([{'activated' : activateChallenge.value?.id === challenge.id}, "round-button d-none d-sm-block"]),
                title: (index + 1)+'회차',
                disabled: !isActive(challenge),
                "no-icon": true,
                onClick: ($event: any) => (selectRound(challenge))
              }, null, 8, ["class", "title", "disabled", "onClick"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.challenges, (challenge, index) => {
              return (_openBlock(), _createBlock(ColaButton, {
                key: challenge.id,
                class: _normalizeClass([{'activated' : activateChallenge.value?.id === challenge.id}, "round-button d-sm-none"]),
                title: (index + 1)+'회차',
                disabled: !isActive(challenge),
                "no-icon": true,
                small: true,
                style: {"min-width":"6.5rem !important"},
                onClick: ($event: any) => (selectRound(challenge))
              }, null, 8, ["class", "title", "disabled", "onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (activateChallenge.value)
          ? (_openBlock(), _createBlock(ChallengeCard, {
              key: 0,
              subtitle: props.challengeType == 'everyone' ? '누구나 참여하는' : '대학생들이 참여하는',
              title: props.challengeType == 'everyone' ? '모두의 챌린지' : '캠퍼스 챌린지',
              "application-period-label": "모집일정",
              "application-period": activateChallenge.value.recruitmentFrom && activateChallenge.value.recruitmentTo ? _unref(formatDateRange)(activateChallenge.value.recruitmentFrom, activateChallenge.value.recruitmentTo) : '',
              "exam-period-label": "수거기간",
              "exam-period": activateChallenge.value.collectionFrom && activateChallenge.value.collectionTo ? _unref(formatDateRange)(activateChallenge.value.collectionFrom, activateChallenge.value.collectionTo) : '',
              "announcement-label": "참여자 발표",
              "announcement-date": __props.challengeType === 'everyone' ? (activateChallenge.value.participantAnnouncement ? _unref(formatDate)(activateChallenge.value.participantAnnouncement) : '') : '모집 마감 후 개별 발표 및 사이트 등록 안내 예정',
              "result-label": "박스발송",
              "result-date": activateChallenge.value.boxDelivery ? _unref(formatDate)(activateChallenge.value.boxDelivery) : '',
              "display-type": 'participate',
              "challenge-type": __props.challengeType
            }, {
              default: _withCtx(() => [
                (props.challengeType === 'campus')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["subtitle", "title", "application-period", "exam-period", "announcement-date", "result-date", "challenge-type"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          ref_key: "formRef",
          ref: formRef,
          onSubmit: _withModifiers(handleSubmit, ["stop","prevent"])
        }, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              ref: "groupNameInputRef",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.group_name) = $event)),
              class: "form-control material",
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.group_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(ParticipantNumberInput, {
              modelValue: form.value.collecting_people_number,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.collecting_people_number) = $event)),
              min: 1,
              max: _unref(maxInput),
              step: 1,
              class: "mt-3 mt-sm-0"
            }, null, 8, ["modelValue", "max"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(ColaButton, {
              type: "submit",
              class: "border-cola d-none d-sm-block",
              title: "참여 신청하기"
            }),
            _createVNode(ColaButton, {
              type: "submit",
              class: "border-cola d-sm-none",
              title: "참여 신청하기",
              small: true,
              "small-icon": true,
              style: {"min-width":"16.6rem"},
              responsive: ""
            })
          ])
        ], 40, _hoisted_8)
      ])
    ])
  ], 64))
}
}

})